function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.2,
  cx: 7,
  cy: 7,
  r: 7,
  transform: "rotate(-90 7 7)",
  fill: "#F5A322"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7 2C7.82225 2 8.63182 2.20279 9.35698 2.59039C10.0821 2.978 10.7005 3.53847 11.1573 4.22215C11.6142 4.90583 11.8953 5.69162 11.9759 6.50991C12.0565 7.32821 11.9341 8.15375 11.6194 8.91342C11.3047 9.67308 10.8076 10.3434 10.172 10.8651C9.53635 11.3867 8.78191 11.7435 7.97545 11.9039C7.169 12.0643 6.33543 12.0234 5.54858 11.7847C4.76173 11.546 4.04589 11.117 3.46447 10.5355L7 7L7 2Z",
  fill: "#F5A322"
});

function SvgPieicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieicon);
export default __webpack_public_path__ + "static/media/pie.icon.9b0e1be5.svg";
export { ForwardRef as ReactComponent };